import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {MeterEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconEdit, IconTrash} from "@tabler/icons-react";

export type MeterAction = "EDIT" | "DELETE"

export type MeterActionMenuDropdownProps = {
  meter: MeterEntity
  onActionClick?: (action: MeterAction) => void
}

export const MeterActionMenuDropdown = (props: MeterActionMenuDropdownProps) => {
  const {meter, onActionClick} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<MeterAction> = useMemo(() => {
    const actions = new Set<MeterAction>()
    if (hasAccess("meter_edit")) {
      actions.add("EDIT")
    }
    if (hasAccess("meter_delete")) {
      actions.add("DELETE")
    }
    return actions
  }, [meter, hasAccess])

  const _onActionClick = useCallback((action: MeterAction) => {
    if (onActionClick) {
      onActionClick(action)
    }
  }, [onActionClick])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {actions.has("EDIT") &&
        <Menu.Item
          onClick={() => _onActionClick("EDIT")}
          icon={<IconEdit size={14}/>}>
          {t("common.action.edit", "Edit")}
        </Menu.Item>
      }
      {actions.has("DELETE") &&
        <>
          {actions.size > 1 && <Menu.Divider/>}
          <Menu.Item
            onClick={() => _onActionClick("DELETE")}
            icon={<IconTrash size={14}/>}
            color="red">
            {t("common.action.delete", "Delete")}
          </Menu.Item>
        </>
      }
    </>
  )
}
